export default "__VITE_ASSET__W5xHHpWD__"